import React from 'react';
import Nav from '../components/Nav';

function About() {
  return (
    <>
      <Nav />
      <div className="container mx-auto  bg-gray-50 text-gray-600 pb-20">
        <section className="relative block h-[500px]">
          <img
            src="banner.png"
            className="absolute top-0 w-full h-full bg-center bg-cover"
            alt=""
          />

          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-20 bg-black"
          ></span>
        </section>

        <section className="bg-gray-100">
          <div className="container mx-auto px-4 ">
            <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="container mx-auto">
                <div className="py-10 container mx-auto mb-20 sm:mx-auto text-justify bg-gray-100 rounded-md p-8">
                  <h1 className="text-2xl font-bold text-blue-900 text-center">
                    ABOUT US
                  </h1>
                  <div className="mb-10">
                    <h1 className="text-lg font-bold text-slate-100 text-left bg-yellow-600 w-32 pl-3 shadow-lg rounded ">
                      OUR STORY
                    </h1>
                    <div className="w-full mt-4 flex lg:flex-row flex-col ">
                      <div className="lg:w-1/2 w-full lg:mx-10">
                        Ex cupidatat amet commodo esse ex deserunt commodo
                        veniam deserunt nulla tempor voluptate sunt
                        reprehenderit. Fugiat commodo voluptate cupidatat velit
                        ex cillum. Veniam minim commodo nulla nostrud cillum
                        duis consequat adipisicing nulla minim qui qui. Nulla
                        irure cillum nostrud anim sint. Dolor amet adipisicing
                        eiusmod ex. Exercitation exercitation velit duis dolor
                        anim aliqua qui qui sit enim. Amet ullamco sint
                        consectetur adipisicing amet ea eiusmod mollit officia
                        magna enim qui. Occaecat pariatur deserunt ea eiusmod
                        non sunt pariatur mollit eu tempor voluptate Lorem
                        adipisicing voluptate. Qui excepteur mollit deserunt
                        magna cupidatat consequat proident culpa exercitation
                        occaecat est nostrud adipisicing. Deserunt sit labore ex
                        adipisicing ut commodo magna nisi. Exercitation irure ad
                        elit consequat elit eiusmod pariatur culpa eu tempor
                        magna ipsum ipsum.
                      </div>
                      <div className="w-full lg:w-1/2 lg:mx-10">
                        <img src="slider-222.jpg" alt="about page" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mb-10">
                      <h1 className="text-lg font-bold text-slate-100 text-left bg-yellow-600 w-32 pl-3 shadow-lg rounded ">
                        SPECIALTIES
                      </h1>
                      <div className="w-full mt-4 flex lg:flex-row flex-col ">
                        <div className="w-full lg:w-1/2 lg:mx-10">
                          <div className="flex flex-row justify-between px-4 ">
                            <span className=" tracking-widest font-light ">
                              SECURITY
                            </span>
                            <span className=" tracking-widest font-light ">
                              100%
                            </span>
                          </div>
                          <div className="overflow-hidden h-2 text-xs flex mb-6 rounded bg-yellow-100">
                            <div
                              style={{ width: '100%' }}
                              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500"
                            ></div>
                          </div>
                          <div className="flex flex-row justify-between px-4 ">
                            <span className=" tracking-widest  font-light ">
                              SALES
                            </span>
                            <span className=" tracking-widest font-light ">
                              90.0%
                            </span>
                          </div>
                          <div className="overflow-hidden h-2 text-xs flex mb-6 rounded bg-yellow-100">
                            <div
                              style={{ width: '90.0%' }}
                              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500"
                            ></div>
                          </div>
                          <div className="flex flex-row justify-between px-4 ">
                            <span className=" tracking-widest   font-light ">
                              FAST DELIVERY
                            </span>
                            <span className=" tracking-widest   font-light ">
                              80%
                            </span>
                          </div>
                          <div className="overflow-hidden h-2 text-xs flex mb-6 rounded bg-yellow-100">
                            <div
                              style={{ width: '80%' }}
                              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500"
                            ></div>
                          </div>
                          <div className="flex flex-row justify-between px-4 ">
                            <span className=" tracking-widest   font-light ">
                              SHIPMENT
                            </span>
                            <span className=" tracking-widest   font-light ">
                              70%
                            </span>
                          </div>
                          <div className="overflow-hidden h-2 text-xs flex mb-6 rounded bg-yellow-100">
                            <div
                              style={{ width: '70%' }}
                              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500"
                            ></div>
                          </div>

                          <div className="flex flex-row justify-between px-4 ">
                            <span className=" tracking-widest   font-light ">
                              PAY ON DELIVERY
                            </span>
                            <span className=" tracking-widest   font-light ">
                              50%
                            </span>
                          </div>
                          <div className="overflow-hidden h-2 text-xs flex mb-6 rounded bg-yellow-100">
                            <div
                              style={{ width: '50%' }}
                              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500"
                            ></div>
                          </div>
                        </div>
                        <div className="lg:w-1/2 w-full lg:mx-10">
                          Ex cupidatat amet commodo esse ex deserunt commodo
                          veniam deserunt nulla tempor voluptate sunt
                          reprehenderit. Fugiat commodo voluptate cupidatat
                          velit ex cillum. Veniam minim commodo nulla nostrud
                          cillum duis consequat adipisicing nulla minim qui qui.
                          Nulla irure cillum nostrud anim sint. Dolor amet
                          adipisicing eiusmod ex. Exercitation exercitation
                          velit duis dolor anim aliqua qui qui sit enim. Amet
                          ullamco sint consectetur adipisicing amet ea eiusmod
                          mollit officia magna enim qui. Occaecat pariatur
                          deserunt ea eiusmod non sunt pariatur mollit eu tempor
                          voluptate Lorem adipisicing voluptate. Qui excepteur
                          mollit deserunt magna cupidatat consequat proident
                          culpa exercitation occaecat est nostrud adipisicing.
                          Deserunt sit labore ex adipisicing ut commodo magna
                          nisi. Exercitation irure ad elit consequat elit
                          eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mb-10">
                      <h1 className="text-lg font-bold text-slate-100 text-left bg-yellow-600 w-36 pl-3 shadow-lg rounded ">
                        TESTIMONIES
                      </h1>

                      <div className="w-full mt-4 flex lg:flex-row flex-col justify-center ">
                        <div className="h-full max-w-[15rem] bg-slate-200 shadow-2xl m-4">
                          <img
                            src="bn8.jpg"
                            alt="about page"
                            className="rounded-full h-48 ml-4 w-48"
                          />
                          <span className="text-gray-800 font-sans font-light group ">
                            <h1 className="text-lg uppercase font-semibold text-center ">
                              Mariama Jones
                            </h1>{' '}
                            <div className="border-b-2 border-yellow-500 w-20 flex translate-all duration-500 justify-center group-hover:w-full" />
                            nisi. Exercitation irure ad elit consequat elit
                            eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                          </span>
                        </div>

                        <div className="h-full max-w-[15rem] bg-slate-200 shadow-2xl m-4">
                          <img
                            src="bn8.jpg"
                            alt="about page"
                            className="rounded-full h-48 ml-4 w-48"
                          />
                          <span className="text-gray-800 font-sans font-light group ">
                            <h1 className="text-lg uppercase font-semibold text-center ">
                              klain Kelly
                            </h1>{' '}
                            <div className="border-b-2 border-yellow-500 w-20 flex translate-all duration-500 justify-center group-hover:w-full" />
                            nisi. Exercitation irure ad elit consequat elit
                            eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                          </span>
                        </div>
                        <div className="h-full max-w-[15rem] bg-slate-200 shadow-2xl m-4">
                          <img
                            src="bn8.jpg"
                            alt="about page"
                            className="rounded-full h-48 ml-4 w-48"
                          />
                          <span className="text-gray-800 font-sans font-light group ">
                            <h1 className="text-lg uppercase font-semibold text-center ">
                              Hellen cane
                            </h1>{' '}
                            <div className="border-b-2 border-yellow-500 w-20 flex translate-all duration-500 justify-center group-hover:w-full" />
                            nisi. Exercitation irure ad elit consequat elit
                            eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                          </span>
                        </div>
                        <div className="h-full max-w-[15rem] bg-slate-200 shadow-2xl m-4">
                          <img
                            src="bn8.jpg"
                            alt="about page"
                            className="rounded-full h-48 ml-4 w-48"
                          />
                          <span className="text-gray-800 font-sans font-light group ">
                            <h1 className="text-lg uppercase font-semibold text-center ">
                              Kofi Kingsley
                            </h1>{' '}
                            <div className="border-b-2 border-yellow-500 w-20 flex translate-all duration-500 justify-center group-hover:w-full" />
                            nisi. Exercitation irure ad elit consequat elit
                            eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                          </span>
                        </div>
                        <div className="h-full max-w-[15rem] bg-slate-200 shadow-2xl m-4">
                          <img
                            src="bn8.jpg"
                            alt="about page"
                            className="rounded-full h-48 ml-4 w-48"
                          />
                          <span className="text-gray-800 font-sans font-light group ">
                            <h1 className="text-lg uppercase font-semibold text-center ">
                              Brad Bush
                            </h1>{' '}
                            <div className="border-b-2 border-yellow-500 w-20 flex translate-all duration-500 justify-center group-hover:w-full" />
                            nisi. Exercitation irure ad elit consequat elit
                            eiusmod pariatur culpa eu tempor magna ipsum ipsum.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-blue-900 text-center">
                      Core value
                    </h1>
                    <p>
                      Et ullamco cillum ex id tempor. Incididunt mollit irure
                      mollit ullamco incididunt adipisicing non nostrud esse eu
                      commodo excepteur et dolor. Nulla pariatur sit pariatur
                      consectetur laborum commodo fugiat veniam voluptate
                      mollit. Ut nostrud quis ipsum consequat ipsum ut duis do
                      commodo commodo aute incididunt cillum. Enim sit veniam
                      laboris nisi eu dolore laborum. Anim reprehenderit et
                      deserunt culpa Lorem commodo aute laborum sunt tempor
                      commodo non veniam et. Officia culpa id esse ad enim nulla
                      aliquip do proident ad mollit adipisicing ut minim.
                      Officia aliquip nostrud dolore commodo nisi excepteur
                      aliquip ea incididunt proident. Ipsum fugiat est aliqua
                      consectetur fugiat tempor irure laboris incididunt aliquip
                      exercitation occaecat. Nostrud fugiat aute irure Lorem
                      irure minim sit et. Esse excepteur sunt excepteur do.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default About;
